"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormHelperTextStyles = exports.useInputLabelStyles = exports.useOutlinedInputStyles = exports.useFilledInputStyles = void 0;

require("core-js/modules/es.array.concat.js");

var _core = require("../core");

var _utils = require("../utils");

var leftDistance = function leftDistance(theme) {
  return "".concat(theme.spacing(2), "px");
};

var useFilledInputStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    error: {
      '& .start-adornment': {
        color: theme.palette.error.main
      }
    },
    focused: {
      '&:not($error) .start-adornment': {
        color: theme.palette.primary.main
      }
    },
    disabled: {},
    multiline: {},
    inputMultiline: {},
    root: {
      caretColor: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[100],
      borderRadius: '4px',
      '&$disabled': {
        backgroundColor: theme.palette.grey[50]
      },
      '&$multiline': {
        alignItems: 'flex-start',
        paddingTop: theme.spacing(3),
        paddingLeft: leftDistance(theme)
      }
    },
    underline: {
      '&:before': {
        borderColor: theme.palette.grey[600]
      },
      '&$disabled:before': {
        borderBottomStyle: 'none'
      }
    },
    adornedStart: {
      color: theme.palette.grey[600],
      paddingLeft: theme.spacing(1.5),
      '&$multiline': {
        paddingLeft: theme.spacing(1.5)
      },
      '&$disabled': {
        color: theme.palette.grey[400]
      }
    },
    adornedEnd: {
      color: theme.palette.grey[600],
      '&$disabled': {
        color: theme.palette.grey[400]
      }
    },
    input: {
      minHeight: theme.spacing(2.375),
      paddingTop: theme.spacing(2.75),
      paddingBottom: theme.spacing(0.875),
      paddingLeft: leftDistance(theme),
      '&$inputMultiline': {
        padding: 0
      }
    },
    inputAdornedStart: {
      paddingLeft: 0,
      marginLeft: theme.spacing(-0.25),
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },
    inputAdornedEnd: {
      color: theme.palette.text.primary,
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
}, {
  name: (0, _core.rochePrefix)('FilledInput')
});
exports.useFilledInputStyles = useFilledInputStyles;
var useOutlinedInputStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    error: {},
    disabled: {},
    multiline: {},
    inputMultiline: {},
    root: {
      caretColor: theme.palette.primary.main,
      backgroundColor: theme.palette.common.white,
      '&$disabled': {
        backgroundColor: theme.palette.grey[50]
      }
    },
    adornedStart: {
      color: theme.palette.grey[600],
      paddingLeft: theme.spacing(1.5),
      '&$disabled': {
        color: theme.palette.grey[400]
      }
    },
    adornedEnd: {
      color: theme.palette.grey[600],
      '&$disabled': {
        color: theme.palette.grey[400]
      }
    },
    notchedOutline: {
      borderColor: theme.palette.grey[600]
    },
    input: {
      minHeight: theme.spacing(2.625),
      paddingTop: theme.spacing(1.625),
      paddingLeft: leftDistance(theme),
      paddingBottom: theme.spacing(1.75)
    },
    inputMarginDense: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(0.875)
    },
    inputAdornedStart: {
      paddingLeft: 0,
      marginLeft: theme.spacing(-0.25),
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },
    inputAdornedEnd: {
      color: theme.palette.text.primary,
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
}, {
  name: (0, _core.rochePrefix)('OutlinedInput')
});
exports.useOutlinedInputStyles = useOutlinedInputStyles;
var useInputLabelStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    filled: {},
    outlined: {},
    shrink: {},
    focused: {},
    error: {},
    disabled: {},
    adornedStart: {},
    marginDense: {},
    root: {
      '&$filled': {
        color: theme.palette.grey[600],
        transform: "translate(".concat(leftDistance(theme), ", ").concat(leftDistance(theme), ") scale(1)"),
        '&$adornedStart': {
          transform: "translate(".concat(theme.spacing(5.25), "px, ").concat(leftDistance(theme), ") scale(1)")
        },
        '&$shrink': {
          '&$adornedStart': {
            transform: "translate(".concat(theme.spacing(5.25), "px, ").concat(theme.spacing(0.85), "px) scale(0.75)")
          },
          '&$error': {
            transform: "translate(".concat(theme.spacing(5.25), "px, ").concat(theme.spacing(0.85), "px) scale(0.75)")
          },
          transform: "translate(".concat(leftDistance(theme), ", ").concat(theme.spacing(0.85), "px) scale(0.75)")
        },
        '&$disabled': {
          color: theme.palette.grey[500]
        },
        '&$error': {
          transform: "translate(".concat(theme.spacing(5.25), "px, ").concat(leftDistance(theme), ") scale(1)")
        }
      },
      '&$outlined': {
        color: theme.palette.grey[600],
        transform: "translate(".concat(leftDistance(theme), ", ").concat(leftDistance(theme), ") scale(1)"),
        '&$marginDense': {
          transform: "translate(".concat(leftDistance(theme), ", ").concat(theme.spacing(1.25), "px) scale(1)"),
          '&$adornedStart:not($shrink)': {
            transform: "translate(".concat(theme.spacing(5.5), "px, ").concat(theme.spacing(1.25), "px) scale(1)")
          }
        },
        '&$adornedStart': {
          transform: "translate(".concat(theme.spacing(5.5), "px, ").concat(leftDistance(theme), ") scale(1)")
        },
        '&$shrink': {
          transform: "translate(".concat(leftDistance(theme), ", ").concat(theme.spacing(-0.75), "px) scale(0.75)")
        },
        '&$disabled': {
          color: theme.palette.grey[500]
        }
      },
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
}, {
  name: (0, _core.rochePrefix)('InputLabel')
});
exports.useInputLabelStyles = useInputLabelStyles;
var useFormHelperTextStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    counter: {},
    root: {
      '&$counter': {
        display: 'flex',
        justifyContent: 'space-between'
      }
    },
    contained: {
      marginLeft: leftDistance(theme)
    }
  };
}, {
  name: (0, _core.rochePrefix)('FormHelperText')
});
exports.useFormHelperTextStyles = useFormHelperTextStyles;